/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_Label_UnvanInputs */

const tr_onbilgi_s1_label_unvan = /** @type {(inputs: Onbilgi_S1_Label_UnvanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticaret Unvanı:`)
};

const en_onbilgi_s1_label_unvan = /** @type {(inputs: Onbilgi_S1_Label_UnvanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade Name:`)
};

const de_onbilgi_s1_label_unvan = /** @type {(inputs: Onbilgi_S1_Label_UnvanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsname:`)
};

const ru_onbilgi_s1_label_unvan = /** @type {(inputs: Onbilgi_S1_Label_UnvanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фирменное наименование:`)
};

/**
* | output |
* | --- |
* | "Trade Name:" |
*
* @param {Onbilgi_S1_Label_UnvanInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_label_unvan = /** @type {((inputs?: Onbilgi_S1_Label_UnvanInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_Label_UnvanInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_label_unvan(inputs)
	if (locale === "de") return de_onbilgi_s1_label_unvan(inputs)
	if (locale === "ru") return ru_onbilgi_s1_label_unvan(inputs)
	return tr_onbilgi_s1_label_unvan(inputs)
});